// extracted by mini-css-extract-plugin
module.exports = {"default":"SuperButton_default__-ADWv","red":"SuperButton_red__5klj7","registrationCancel":"SuperButton_registrationCancel__2mLUv","disabled":"SuperButton_disabled__3GKZp"};